import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Clock, Info } from "lucide-react";
import Logo from "@/components/Logo";
import api from "@/lib/api";

const DEFAULT_FOOTER = {
  phone: "",
  address: "Campus UNISIC, Kinshasa",
  email: "contact@unisic-recherche.net",
  hours: "",
  extra: "",
};

export default function PublicFooter() {
  const [footer, setFooter] = useState(DEFAULT_FOOTER);

  useEffect(() => {
    api
      .get("/content/site.footer")
      .then((r) => {
        if (r.data && Object.keys(r.data).length) {
          setFooter({ ...DEFAULT_FOOTER, ...r.data });
        }
      })
      .catch(() => {});
  }, []);

  return (
    <footer className="bg-unisic-blue text-slate-200 mt-24" data-testid="public-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div>
          <Logo variant="light" />
          <p className="mt-4 text-sm text-slate-300 leading-relaxed">
            Portail officiel du Secrétariat Général à la Recherche de l'Université des Sciences
            de l'Information et de la Communication.
          </p>
        </div>
        <div>
          <div className="eyebrow">Directions</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/directions/bibliotheques-musees" className="hover:text-unisic-gold">Recherche, Bibliothèques et Musées</Link></li>
            <li><Link to="/directions/ecole-doctorale" className="hover:text-unisic-gold">École Doctorale</Link></li>
            <li><Link to="/directions/suivi-encadrement" className="hover:text-unisic-gold">Suivi et Encadrement</Link></li>
            <li><Link to="/directions/bibliotheques-musees/cecom" className="hover:text-unisic-gold">CECOM</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow">Plateformes</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/plateformes/depots" className="hover:text-unisic-gold">Dépôts académiques</Link></li>
            <li><Link to="/plateformes/archives-academiques" className="hover:text-unisic-gold">Dépôt institutionnel</Link></li>
            <li><Link to="/plateformes/revues" className="hover:text-unisic-gold">Cahiers Congolais de Communication</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow">Contact</div>
          <ul className="mt-4 space-y-2 text-sm text-slate-300">
            {footer.address && (
              <li className="flex items-start gap-2" data-testid="footer-address">
                <MapPin className="w-4 h-4 mt-0.5 text-unisic-gold flex-shrink-0" />
                <span>{footer.address}</span>
              </li>
            )}
            {footer.email && (
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-unisic-gold flex-shrink-0" />
                <a
                  href={`mailto:${footer.email}`}
                  className="hover:text-unisic-gold"
                  data-testid="footer-contact-email"
                >
                  {footer.email}
                </a>
              </li>
            )}
            {footer.phone && (
              <li className="flex items-center gap-2" data-testid="footer-phone">
                <Phone className="w-4 h-4 text-unisic-gold flex-shrink-0" />
                <a href={`tel:${footer.phone.replace(/\s+/g, "")}`} className="hover:text-unisic-gold">
                  {footer.phone}
                </a>
              </li>
            )}
            {footer.hours && (
              <li className="flex items-start gap-2" data-testid="footer-hours">
                <Clock className="w-4 h-4 mt-0.5 text-unisic-gold flex-shrink-0" />
                <span>{footer.hours}</span>
              </li>
            )}
            {footer.extra && (
              <li className="flex items-start gap-2" data-testid="footer-extra">
                <Info className="w-4 h-4 mt-0.5 text-unisic-gold flex-shrink-0" />
                <span>{footer.extra}</span>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between text-xs text-slate-400">
          <span>© {new Date().getFullYear()} UNISIC-Recherche — Secrétariat Général à la Recherche</span>
          <span data-testid="footer-credits">Site développé et maintenu par <span className="text-unisic-gold font-semibold">Eliah Consulting</span></span>
        </div>
      </div>
    </footer>
  );
}
